import { Pipe, PipeTransform } from '@angular/core';
import { TranslateForCrmObjectService } from './translate-for-crm-object.service';
import { Observable } from 'rxjs';
import { ActivityType, ObjectType } from '../../tokens-and-interfaces';

@Pipe({
  name: 'translateForCrmObject',
  standalone: true,
})
export class TranslateForCrmObjectPipe implements PipeTransform {
  constructor(private readonly translateForCrmObjectService: TranslateForCrmObjectService) {}

  // eslint-disable-next-line @typescript-eslint/ban-types
  transform(value: string, objectType: ObjectType | ActivityType, interpolationParams?: Object): Observable<string> {
    return this.translateForCrmObjectService.getTranslationForCrmObject(objectType, value, interpolationParams);
  }
}
